import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./pages/Home";
import Mypage from "./pages/Mypage";
import Quiz from "./pages/Quiz";
import QuizMistakes from "./pages/QuizMistakes";
import reportWebVitals from "./reportWebVitals";
import liff from "@line/liff";
import { SubscribeModalProvider } from "./providers/SubscribeModalProvider";
import { UserRegistrationProvider } from "./providers/UserRegistrationProvider";
import RegistrationModal from "./components/registration/RegistrationModal";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// クイズはLINEログインなしで参加できるため、外部ブラウザでも強制ログインさせない
const isGuestRoute = window.location.pathname.startsWith("/quiz");

liff
  .init({
    liffId: process.env.REACT_APP_LIFF_ID || "",
    withLoginOnExternalBrowser: !isGuestRoute,
  })
  .then(() => {
    root.render(
      <React.StrictMode>
        <SubscribeModalProvider>
          <UserRegistrationProvider>
            <RegistrationModal />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/mypage" element={<Mypage />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/quiz/mistakes" element={<QuizMistakes />} />
              </Routes>
            </BrowserRouter>
          </UserRegistrationProvider>
        </SubscribeModalProvider>
      </React.StrictMode>
    );
  })
  .catch((e) => {
    alert(`LIFF error: ${e.message}`);
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
